export const GET_WEALTH_LEAD_DETAILS = 'GET_WEALTH_LEAD_DETAILS';
export const GET_WEALTH_LEAD_DETAILS_SUCCESS = 'GET_WEALTH_LEAD_DETAILS_SUCCESS';
export const GET_WEALTH_LEAD_DETAILS_ERROR = 'GET_WEALTH_LEAD_DETAILS_ERROR';
export const WEALTH_SUBMIT_FORM = 'WEALTH_SUBMIT_FORM';
export const WEALTH_SUBMIT_FORM_SUCCESS = 'WEALTH_SUBMIT_FORM_SUCCESS';
export const WEALTH_SUBMIT_FORM_ERROR = 'WEALTH_SUBMIT_FORM_ERROR';
export const CLOSE_SUCCESS_POPUP = 'CLOSE_SUCCESS_POPUP';
